export default __webpack_public_path__ + "static/media/etudes.1ed1a75c.svg";